/**
 * Окно кода второго фактора.
 *
 * Появляется само, когда сервер отвечает «нужен код». Экраны об этом не знают
 * и знать не должны: опасных кнопок больше десятка, и просить код в каждом
 * обработчике значило бы однажды забыть про одну.
 *
 * Ставится один раз в приложении и подписывается на транспорт.
 */
import { useEffect, useRef, useState } from 'react';
import { onOtpNeeded } from '../transport/socket.ts';
import type { MethodName } from '../../shared/protocol/methods.ts';

interface Ask {
  method: MethodName;
  resolve: (code: string | null) => void;
}

export function OtpPrompt(): React.JSX.Element | null {
  const [ask, setAsk] = useState<Ask | null>(null);
  const [code, setCode] = useState('');
  const input = useRef<HTMLInputElement>(null);

  useEffect(() => {
    onOtpNeeded((method) => new Promise<string | null>((resolve) => {
      setCode('');
      setAsk({ method, resolve });
    }));
  }, []);

  useEffect(() => {
    if (ask) input.current?.focus();
  }, [ask]);

  if (!ask) return null;

  const close = (value: string | null): void => {
    ask.resolve(value);
    setAsk(null);
    setCode('');
  };

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-label="Код второго фактора">
      <form
        className="modal__box"
        onSubmit={(e) => { e.preventDefault(); close(code.trim() || null); }}
      >
        <h3 className="modal__title">Подтвердите действие</h3>
        <p className="modal__text">
          Это опасное действие: <code className="mono">{ask.method}</code>.
          Назовите шесть цифр из приложения-аутентификатора — или запасной код,
          если телефона под рукой нет.
        </p>
        <input
          ref={input}
          className="input otp__input mono"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="000000"
          maxLength={32}
        />
        <div className="modal__actions">
          <button type="button" className="button button--ghost" onClick={() => close(null)}>
            Отмена
          </button>
          <button type="submit" className="button" disabled={code.trim().length < 4}>
            Подтвердить
          </button>
        </div>
      </form>
    </div>
  );
}
